import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contact_us } from "../../component/services/ApiCalls";
import "../sass/MottruckLanding.scss";
import "./ContactDemo.scss";

const OPTIONS = ["Connect with carriers", "Onboarding carriers", "Carrier network"];
const COUNTRIES = [
  "France",
  "Belgium",
  "Netherlands",
  "Germany",
  "Spain",
  "Italy",
  "Poland",
  "Portugal",
  "Romania",
  "Other",
];
const PHONE_CODES = ["+33", "+32", "+31", "+49", "+34", "+39", "+48", "+351", "+40", "+44"];

const Demo = () => {
  const [solution, setSolution] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    company: "",
    country: "France",
    email: "",
    phoneCode: "+33",
    phone: "",
    slot1Date: "",
    slot1Time: "",
    slot2Date: "",
    slot2Time: "",
  });

  const setField = (key) => (e) =>
    setForm((prev) => ({ ...prev, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    const {
      firstName,
      lastName,
      company,
      country,
      email,
      phoneCode,
      phone,
      slot1Date,
      slot1Time,
      slot2Date,
      slot2Time,
    } = form;

    if (
      ![firstName, lastName, company, email, phone, slot1Date, slot1Time, slot2Date, slot2Time].every(
        (v) => String(v).trim().length > 0
      )
    ) {
      toast("Please fill in all fields.");
      return;
    }

    const name = `${firstName.trim()} ${lastName.trim()}`;
    const fullPhone = `${phoneCode} ${phone.trim()}`;
    const message = [
      `Solution: ${OPTIONS[solution]}`,
      `Country: ${country}`,
      `Preferred slot 1: ${slot1Date} ${slot1Time}`,
      `Preferred slot 2: ${slot2Date} ${slot2Time}`,
    ].join("\n");

    setSubmitting(true);
    try {
      const res = await contact_us({
        name,
        email: email.trim(),
        phone: fullPhone,
        company: company.trim(),
        message,
        subject: "Demo request",
      });
      if (res.status == 1) {
        toast("Thanks, we will confirm a demo slot asap.");
        setForm({
          firstName: "",
          lastName: "",
          company: "",
          country: "France",
          email: "",
          phoneCode: "+33",
          phone: "",
          slot1Date: "",
          slot1Time: "",
          slot2Date: "",
          slot2Time: "",
        });
        setSolution(0);
      } else {
        toast("Something went wrong. Please try again.");
      }
    } catch (err) {
      console.log("err", err);
      toast("Something went wrong. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mtk-landing mtk-split-page mtk-demo-page">
      <section className="mtk-split-section">
        <div className="mtk-split-grid">
          <div className="mtk-split-left mtk-demo-left">
            <h1>Book your demo.</h1>
            <p className="mtk-demo-lead">
              Tell us about your company, pick two time slots that suit you and
              choose the solution you want to see. We come back to you with a
              confirmed slot.
            </p>
            <div className="mtk-demo-bullets">
              {[
                "30 minutes, online, with a member of our team",
                "A walkthrough on your own transport flows",
                "No commitment, no setup fee",
              ].map((t) => (
                <div key={t} className="bullet">
                  <span className="dot" />
                  <span>{t}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mtk-split-right mtk-demo-right">
            <form className="mtk-demo-form" onSubmit={onSubmit}>
              <div className="field">
                <label>Solution you are interested in</label>
                <div className="mtk-demo-chips">
                  {OPTIONS.map((label, i) => (
                    <button
                      key={label}
                      type="button"
                      className={solution === i ? "on" : ""}
                      onClick={() => setSolution(i)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="field-row">
                <div className="field">
                  <label>First name</label>
                  <input
                    type="text"
                    placeholder="John"
                    value={form.firstName}
                    onChange={setField("firstName")}
                  />
                </div>
                <div className="field">
                  <label>Last name</label>
                  <input
                    type="text"
                    placeholder="Carter"
                    value={form.lastName}
                    onChange={setField("lastName")}
                  />
                </div>
              </div>

              <div className="field-row company-country">
                <div className="field">
                  <label>Company</label>
                  <input
                    type="text"
                    placeholder="Your company"
                    value={form.company}
                    onChange={setField("company")}
                  />
                </div>
                <div className="field">
                  <label>Country</label>
                  <select value={form.country} onChange={setField("country")}>
                    {COUNTRIES.map((c) => (
                      <option key={c}>{c}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="field-row email-phone">
                <div className="field">
                  <label>Working email</label>
                  <input
                    type="email"
                    placeholder="name@company.com"
                    value={form.email}
                    onChange={setField("email")}
                  />
                </div>
                <div className="field">
                  <label>Phone</label>
                  <div className="phone-row">
                    <select value={form.phoneCode} onChange={setField("phoneCode")}>
                      {PHONE_CODES.map((c) => (
                        <option key={c}>{c}</option>
                      ))}
                    </select>
                    <input
                      type="text"
                      placeholder="6 00 00 00"
                      value={form.phone}
                      onChange={setField("phone")}
                    />
                  </div>
                </div>
              </div>

              <div className="field-row slots-row">
                <div className="field">
                  <label>Preferred slot 1</label>
                  <div className="slot-row">
                    <input
                      type="date"
                      value={form.slot1Date}
                      onChange={setField("slot1Date")}
                    />
                    <input
                      type="time"
                      value={form.slot1Time}
                      onChange={setField("slot1Time")}
                    />
                  </div>
                </div>
                <div className="field slot-2">
                  <label>Preferred slot 2</label>
                  <div className="slot-row">
                    <input
                      type="date"
                      value={form.slot2Date}
                      onChange={setField("slot2Date")}
                    />
                    <input
                      type="time"
                      value={form.slot2Time}
                      onChange={setField("slot2Time")}
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="mtk-demo-submit" disabled={submitting}>
                {submitting ? "Sending…" : "Request my demo →"}
              </button>
            </form>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default Demo;
